import {
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  VisuallyHidden,
} from '@chakra-ui/react';
import * as React from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useLanguageSelector } from './hooks/useLanguageSelector';

export const LanguageSelector: React.FC = (): JSX.Element => {
  const { changeLanguage, language, languages } = useLanguageSelector();
  return (
    <Menu>
      <MenuButton
        _hover={{ boxShadow: 'none' }}
        as={Button}
        p={0}
        rightIcon={<Icon as={FaChevronDown} m={0} ml="-1rem" />}
      >
        <language.icon h="56px" w="56px" />
      </MenuButton>
      <MenuList bg="brand.black" color="white" minW="max-content">
        {languages
          .filter((l) => l.id !== language.id)
          .map((lng) => (
            <MenuItem
              _active={{ bg: 'transparent' }}
              _focus={{ bg: 'transparent' }}
              key={`language-${lng.id}`}
              p={0}
              onClick={(): void => {
                changeLanguage(lng.id);
              }}
            >
              <VisuallyHidden>{lng.label}</VisuallyHidden>
              <lng.icon h="64px" w="64px" />
            </MenuItem>
          ))}
      </MenuList>
    </Menu>
  );
};
